// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable func-names */
import { parseISO } from "date-fns"
import R from "ramda"

import type {
  BookingLockedInput,
  BookingLocked,
  BookingLockedCredentialsInput,
  BookingLockedCredentials,
} from "../../../../BookingLocked/services/types"

export default function (input: BookingLockedInput): BookingLocked {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!input.credentials) {
    // @ts-expect-error: Flow to TS migration.
    return {}
  }
  return {
    credentials: R.sortBy(
      R.prop("departure"),
      input.credentials.map<BookingLockedCredentials>(
        (credential: BookingLockedCredentialsInput) => ({
          segmentCode: credential.segment_code,
          pid: credential.passenger_id,
          pnr: credential.pnr,
          // Fix this the next time the file is edited. (Flow to TS)
          // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
          name: credential.name || "",
          // Fix this the next time the file is edited. (Flow to TS)
          // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
          surname: credential.surname || "",
          email: credential.email,
          eticketNumber: credential.eticket_number,
          password: credential.password,
          stationIata: credential.station_iata,
          // Fix this the next time the file is edited. (Flow to TS)
          // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
          departure: parseISO(credential.departure || ""),
          carrierSegmentCode: credential.carrier_segment_code,
          dob: credential.dob,
          airlineMMBLink: credential.airline_mmb_link,
          phoneNumber: credential.phone_number,
          creditCard: credential.credit_card,
          refundFormLink: credential.refund_form_link,
          autoRefundStatus: credential.auto_refund,
        }),
      ),
    ),
  }
}
